import React from 'react';
import styles from './styles.module.scss';
import util from '../../util';
import strings from '../../globalization';
import Flex from '../Flex';
import DOMPurify from 'dompurify';
// eslint-disable-next-line max-lines-per-function
const CustomInput = ({
  stateField,
  inputType,
  inputLable,
  onTextChange,
  onKeyDown,
  placeholder,
  onLabelPress,
  style,
  value,
  keyboardType = 'default',
  textStyle,
  leftIcon,
  rightIcon,
  fileIcon,
  showBottomRightLabel,
  rightLabel,
  onIconClick,
  toggleEyeIcon,
  showIcon = false,
  iconName = '',
  inputLabelStyle,
  isNumber = false,
  containerStyle,
  required = false,
  placeholderColor = '#D3D3D4',
  error,
  onBlur,
  maxLength,
  tabIndex,
  labelStyles,
  containerStyles,
  iconStyles,
  type,
  onRightIconClick,
  inputBoxClassName,
  containerClassNames,
  labelClassNames,
  isEdit,
  disabled,
  uppercase = false,
  disableCopyPaste = false,
  ...inputProps
}: Props) => {
  const textChangeHandler = text => {
    if (isNumber && +text < 0) {
      util.throwError(`${inputLable} ${strings.cannotBeNegative}`);
      return;
    }
    if (uppercase) {
      text = text.toUpperCase();
    }
    text = text.replace(/\s+/g, ' ');
    // let trimmed = text.trim();
    const sanitizedInputValue = DOMPurify.sanitize(text);

    onTextChange(sanitizedInputValue);
  };

  return (
    <div style={containerStyles} className={styles.container}>
      <Flex direction="row" className={styles.labelContainer}>
        <p className={[styles.label, labelStyles, labelClassNames].join(' ')}>
          {inputLable}
        </p>
        {required ? <span style={{ color: 'red' }}>*</span> : null}
      </Flex>

      <Flex
        style={style}
        className={[
          styles.inputBox,
          inputBoxClassName,
          containerClassNames,
        ].join(' ')}>
        {leftIcon && (
          <Flex direction="column" className={styles.imageContainer}>
            <img
              alt="U"
              src={leftIcon}
              className={styles.leftIconStyles}
              style={iconStyles}
            />
          </Flex>
        )}
        <input
          // {...inputProps}
          tabIndex={tabIndex}
          className={styles.input}
          value={value}
          placeholder={placeholder}
          // secureTextEntry={inputType}
          onPaste={e => {
            if (disableCopyPaste) {
              e.preventDefault();
              return false;
            } else {
              return true;
            }
          }}
          onCopy={e => {
            if (disableCopyPaste) {
              e.preventDefault();
              return false;
            } else {
              return true;
            }
          }}
          onChange={e => textChangeHandler(e.target.value)}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          maxLength={maxLength}
          spellCheck="false"
          type={type}
          disabled={disabled}
          style={
            disabled ? { backgroundColor: '#FAFAFA', color: '#000000' } : null
          }
          {...inputProps}
        />
        {rightIcon && (
          <Flex
            direction="column"
            onClick={onRightIconClick}
            className={styles.rightImageContainer}>
            <img
              alt="U"
              src={rightIcon}
              className={styles.rightIconStyles}
              style={iconStyles}
            />
          </Flex>
        )}
        {fileIcon && (
          <Flex
            direction="column"
            onClick={onRightIconClick}
            className={styles.fileContainer}>
            View Document
          </Flex>
        )}
      </Flex>

      <Flex style={{ width: '100%', height: '1rem' }}>
        <p className={styles.error}>{error}</p>
      </Flex>
    </div>
  );
};

export default CustomInput;
